// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers. The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerMyRepStyles } from "@conklin/App/Widgets/Header/HeaderMyRep";
import { LazyImageStyle } from "@conklin/MobiusOverrides/LazyImage";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

const containerStyles = css`
    display: flex;
    align-items: start;
    gap: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    ${LazyImageStyle} {
        flex: 0 0 64px;
    }
`;

headerMyRepStyles.repWrapper = {
    css: css`
        min-width: 300px;
        height: 100%;
        background-color: ${color("common.background")};
    `,
};

headerMyRepStyles.repHeader = {
    css: css`
        padding: 8px 12px;
        color: ${color("common.ui1")};
        background-color: ${color("primary.main")};
    `,
};

headerMyRepStyles.repMainTitle = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

headerMyRepStyles.repBody = {
    css: css`
        padding: 0 12px;
    `,
};

headerMyRepStyles.primaryRepContainer = {
    css: css`
        ${containerStyles}
    `,
};

headerMyRepStyles.secondaryRepContainer = {
    css: css`
        ${containerStyles}
        border-top: 1px solid ${color("common.border")};
    `,
};

headerMyRepStyles.repDetails = {
    css: css`
        display: flex;
        align-items: start;
        flex-direction: column;
        gap: 8px;
    `,
};

headerMyRepStyles.repImage = {
    width: "64px",
    height: "64px",
    css: css`
        min-width: 64px;
        border-radius: 50%;
    `,
};

headerMyRepStyles.repContact = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

headerMyRepStyles.repTitle = {
    variant: "h6",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

headerMyRepStyles.repName = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.regular,
};

headerMyRepStyles.repSupportContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 12px 0;
        min-height: 53px;
        border-top: 1px solid ${color("common.border")};
    `,
};

headerMyRepStyles.supportName = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.bold,
};

headerMyRepStyles.repLink = {
    css: css`
        ${TypographyStyle} {
            font-size: 12px;
            line-height: 15px;
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};

headerMyRepStyles.repHours = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.regular,
};
